module.exports = __webpack_public_path__ + "img/weibo.07d29086.svg";